import { useTheme } from '@mui/material/styles';
import { Avatar, Box, colors, Link, List, ListItem, ListItemIcon, ListItemText, Stack, Typography} from '@mui/material';
import Container from '../../../components/Container';

const steps = [
    {
      title: 'Organization',
      description:(
        <Typography variant={'subtitle2'}>
            Local filers organize with the local election official, usually the city or town clerk, by filing the <Link underline="none" href="https://ocpf2.blob.core.windows.net/pdf/forms/cpf_m101_18_new.pdf" target="_blank">M101 form</Link>. 
            Even candidates without a committee file the <Link underline="none" href="https://ocpf2.blob.core.windows.net/pdf/forms/cpf_m101_18_new.pdf" target="_blank">M101</Link>, but check the "candidate only" box.
        </Typography>
      )
    },
    {
      title: 'OCPF Guides',
      description:(
        <Typography variant={'subtitle2'}>
            Provide OCPF's guide to all candidates by e-mail or by printing it. The guide is designed to answer nearly all their questions. 
            Click here to get the <Link underline="none" href="https://ocpf2.blob.core.windows.net/pdf/guides/municipalcandidatebook.pdf" target="_blank">Guide</Link>.
        </Typography>
      )
    },
    {
      title: 'Bank',
      description:(
        <Typography variant={'subtitle2'}>
           Local filers open a standard checking account to deposit contributions. 
           Most banks require an <Link underline="none" href="/PublicSearch?q=EIN" target="_blank">EIN from the IRS</Link> to open an account.
        </Typography>
      )
    },
    {
      title: 'Reporting',
      description:(
        <Stack spacing={1}>
             <Typography variant={'subtitle2'}>
                In towns, file the <Link underline="none" href="https://ocpf2.blob.core.windows.net/pdf/forms/M102_edit.pdf" target="_blank">M102 campaign finance form</Link> eight days before the election and 30 days afterward. 
                A pre-preliminary report is due if a candidate's name appears on a preliminary ballot. The reporting period dates can be calculated <Link underline="none" href="" target="_blank">here</Link>. 
            </Typography>
            <Typography variant={'subtitle2'}>
                In cities, local filers file the <Link underline="none" href="https://ocpf2.blob.core.windows.net/pdf/forms/M102_edit.pdf" target="_blank">M102 campaign finance form</Link> campaign finance form eight days before the preliminary election, if the filers appear on the preliminary ballot, and eight days before the general election.
            </Typography>
        </Stack>
       
      )
     },
    {
      title: ' Year-end reports',
      description:(
        <Typography variant={'subtitle2'}>
           Year-end reports are filed each Jan. 20 by municipal candidates.
        </Typography>
      )
    }
  ];

const GettingStarted = (): JSX.Element => {

    const theme = useTheme();

    return (
    <Box marginTop={5} marginBottom={5}>
        <Box marginBottom={3}>
        <Typography
         variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          data-aos={'fade-up'}
          fontWeight={700}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          Getting the Local Filers Started
        </Typography>
        </Box>
        <Box bgcolor="alternate.main">
        <Container maxWidth={800}>
          <List
          sx={{
            width: '100%',
            bgcolor: 'background.paper',
            padding: 2,
            borderRadius: 2,
            boxShadow: 2,
          }}
        >
          {steps.map((step, i) => (
            <ListItem sx={{ alignItems: 'unset' }} key={i}>
              <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
              >
                <ListItemIcon sx={{ minWidth: 'auto' }}>
                  <Box
                    component={Avatar}
                    width={50}
                    height={50}
                    marginBottom={2}
                    bgcolor={colors.blue[500]}
                    color={theme.palette.background.paper}
                  >
                    {i + 1}
                  </Box>
                </ListItemIcon>
                <Box
                  display={i === steps.length - 1 ? 'none' : 'flex'}
                  flex={'1 1 0%'}
                  borderRight={`1px solid ${theme.palette.divider}`}
                />
              </Box>
              <Box marginLeft={2}>
                <ListItemText
                  primary={step.title}
                  primaryTypographyProps={{ fontWeight: 700 }}
                />
                <Box marginTop={2}>
                    {step.description}
                </Box>
              </Box>
            </ListItem>
          ))}
          </List>
        </Container>
        </Box>
    </Box>
    )
}

export default GettingStarted;